import styled from "styled-components"

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const ErrorCode = styled.h2`
  font-size: 70px;
  margin: 0;
`